export default "__VITE_ASSET__BtA3Tbnw__"